import './App.css';
import CardGroup from './components/CardGroup';

function App() {

  return (
    <div className="container">
     <CardGroup/>
    </div>
  );
}

export default App;
